module.exports = __webpack_public_path__ + "static/blast-galaxy-background-062be7f0d9943986eafb371840c231ba.mp4";